import { ArrowCircleRight, Info, Map } from "@mui/icons-material";
import {
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import { INCOMLEND_INTERNAL_LINK, MAPS } from "codes";
import history from "helpers/history";

import moment from "moment";
import React from "react";

type ScoreType = "Low" | "Medium Low" | "Medium" | "Medium High" | "High";

interface MapTable {
  map_id: string;
  buyer: string;
  seller: string;
  relationship_id: string;
  score: ScoreType;
  next_monitoring_date: Date;
}

interface MonitoringListProps {
  map: MapTable;
  overdue?: boolean;
}

const MonitoringList: React.FC<MonitoringListProps> = (props) => {
  const { map, overdue } = props;

  return (
    <ListItem
      onClick={() =>
        history.push(`${INCOMLEND_INTERNAL_LINK}${MAPS}/${map.map_id}`)
      }
      secondaryAction={
        <IconButton
          edge="end"
          aria-label="go-to-map"
          size="small"
          onClick={() =>
            history.push(`${INCOMLEND_INTERNAL_LINK}${MAPS}/${map.map_id}`)
          }
        >
          <ArrowCircleRight color="error" fontSize="small" />
        </IconButton>
      }
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        cursor: "pointer",
        my: 0.25,
        py: 0.5,
        px: 1,
        ":hover": {
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.20) inset",
          bgcolor: "rgba(0,0,0,0.02)",
        },
        boxShadow: "0px 0px 3px 0px rgba(0,0,0,0.05) inset",
      }}
    >
      <ListItemAvatar sx={{ minWidth: 36 }}>
        <Avatar sx={{ bgcolor: "error.main", width: 24, height: 24 }}>
          <Map fontSize="small" />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box sx={{ fontSize: '0.75rem' }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
              <Typography variant="caption" fontWeight="bold">Supplier:</Typography>
              <Typography variant="caption" color="error">{map.seller}</Typography>
              <Typography variant="caption" sx={{ mx: 0.25 }}>-</Typography>
              <Typography variant="caption" fontWeight="bold">Buyer:</Typography>
              <Typography variant="caption" color="error">{map.buyer}</Typography>
              <Typography variant="caption" fontWeight="bold" sx={{ ml: 0.5 }}>{map.map_id}</Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', ml: 0.5 }}>
                <Typography variant="caption">{overdue ? "overdue by" : "due in"}</Typography>
                <Typography variant="caption" color="error" sx={{ ml: 0.5, fontWeight: 'bold' }}>{`${
                  overdue
                    ? moment(moment()).diff(
                        moment(map.next_monitoring_date),
                        "days"
                      )
                    : moment(map.next_monitoring_date).diff(moment(), "days") + 1
                } days`}</Typography>
                <Tooltip
                  title={`Next monitoring date: ${moment(map.next_monitoring_date).format("DD/MM/YY")}`}
                >
                  <Info fontSize="inherit" sx={{ ml: 0.5, fontSize: '0.75rem' }} />
                </Tooltip>
              </Box>
            </Box>
          </Box>
        }
      />
    </ListItem>
  );
};

export default MonitoringList;
